// eslint-disable-next-line jira/import/no-restricted-import
import { fieldsResource } from '@jira/router-resources__business-fields/src/fieldsResource.tsx';
// eslint-disable-next-line camelcase, jira/import/no-restricted-import
import { DEPRECATED_DO_NOT_USE_projectDetailsResource } from '@jira/router-resources__business-project-details/src/BusinessProjectDetailsUseProjectDEPRECATEDDONOTUSE.tsx';
import { projectCreatePermissionsResource } from '@jira/router-resources__project-permissions/src/projectCreatePermissionsResource.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import type { Field } from '@jira/router-resources__business-fields/src/FieldEdge.types.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import type { ProjectDetailsResource } from '@jira/router-resources__business-project-details/src/ProjectDetailsResource.types.tsx';

import type { ProjectPermissions } from '@jira/router-resources__project-permissions/src/ProjectPermissions.types.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

export const getListProjectResources = (): (
	| RouteResource<ProjectPermissions | null>
	| RouteResource<ProjectDetailsResource>
	| RouteResource<Field[] | null>
)[] => [
	projectCreatePermissionsResource,
	// eslint-disable-next-line camelcase
	DEPRECATED_DO_NOT_USE_projectDetailsResource,
	fieldsResource,
];
